import { Alignment, ComponentSize, TextColor } from '../../../types';
import { TextButton } from '../Button';
import { Icons } from '../Icons';
import { Typography } from '../Typography';
import { EMPTY_STATE_SIZE_CONFIG } from './EmptyState.constants';
import { EmptyStateProps } from './EmptyState.types';

const EmptyState = ({ description, size = ComponentSize.SMALL, title, ctaButtonProps, icon }: EmptyStateProps) => {
  const { iconSize, titleType, descriptionType } = EMPTY_STATE_SIZE_CONFIG[size];
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4">
      <div className="flex flex-col items-center justify-center gap-2">
        {icon && <Icons icon={icon} size={iconSize} />}
        <Typography type={titleType} alignment={Alignment.CENTER}>
          {title}
        </Typography>
        <Typography alignment={Alignment.CENTER} type={descriptionType} color={title ? TextColor.SECONDARY : undefined}>
          {description}
        </Typography>
      </div>
      {ctaButtonProps && <TextButton size={size} {...ctaButtonProps} />}
    </div>
  );
};

export default EmptyState;
